// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum PersonType {
	NaturalPerson = 1,
	Company = 2,
}
